exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "hr.line[data-v-ac8b5ac6]{margin:10px 0;border:0;height:2px;background-image:linear-gradient(90deg,transparent,rgba(0,0,0,.75),transparent)}.title[data-v-ac8b5ac6]{font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-ac8b5ac6&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ComponentTitle.vue
// module id = 929
// module chunks = 2